import { memoize } from 'redux-memoize';
import { dispatchAsyncFnStatusActions } from '../../lib';
import { onEnterTerminal } from './ui-actions';

export const loadTerminalCrewMembers = memoize(
  { ttl: 60000 },
  ({ api, crewId, disabledAt }) =>
    (dispatch) =>
      dispatchAsyncFnStatusActions({
        dispatch,
        actionName: 'LOAD_TERMINAL_CREW_MEMBERS',
        fnParams: { crewId, disabledAt, requireActiveTimeAccountId: true },
        fn: async (params) => {
          await dispatch(onEnterTerminal({ api }));
          return api.getCrewMembers(params);
        },
      })
);
